import React from "react";
import ReactDOM from "react-dom";

import Application from "./Application";
import ErrorBoundary from "./common/ErrorBoundary";


// To hide that resize warning ----------------------------------------

// Suppress ResizeObserver loop warning (benign browser notification)
const resizeObserverErr = window.onerror;
window.onerror = (msg, ...args) => {
    if (msg?.includes('ResizeObserver loop')) return true; // suppress
    return resizeObserverErr?.(msg, ...args);
};


window.addEventListener('error', (e) => {
    if (e.message?.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation(); // prevents React overlay from catching it
    }
});

window.addEventListener('error', (e) => {
    if (
        e?.message?.includes('ResizeObserver loop') ||
        e?.message?.includes('ResizeObserver Loop')
    ) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return true;
    }
});

const observer = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends observer {
    constructor(callback) {
        super((entries, ob) => {
            requestAnimationFrame(() => {
                callback(entries, ob);
            });
        });
    }
};



// -------------------------------------------------------------------
ReactDOM.render(
    <ErrorBoundary>
        <Application />
    </ErrorBoundary>,
    document.querySelector("#root")
);

// React Query Auth login
// https://www.reddit.com/r/reactjs/comments/jd5oxu/does_reactquery_make_sense_in_an_auth_provider/

// React Query 7 Tips
// https://betterprogramming.pub/7-tips-for-using-react-query-in-large-projects-22ccc49d61c2

// React Query Error Handling
// https://tkdodo.eu/blog/react-query-error-handling

// Axios Refresh Token
// https://medium.com/swlh/handling-access-and-refresh-tokens-using-axios-interceptors-3970b601a5da

// Regex for {{value}}::  \{\{[a-zA-Z]+\}\}
// Regex ofr {{valeu}} new::  \{\{[^}]*\}\}
